import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from "rxjs/operators";
import { CommunicationConstants } from '../constants/communication';
//TODO import { SecureStorageService } from '../services/secure-storage.service';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {

    constructor(
    //TODO private secureStorageService:SecureStorageService
    ){}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request)
            .pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        //TODO let data = this.secureStorageService.decrypt(event.body.toString())
                        event = event.clone({ body: JSON.parse(event.body.body) });
                    }
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    let errorMsg: string;
                    const [codigosCom, mensajesCom] = CommunicationConstants;
                    if (error.error instanceof ErrorEvent) {
                        errorMsg = `${codigosCom.ERRORCLT}||${mensajesCom.ERRORCLT}`;
                    } else {

                        if(error.status === 400){
                            let message = error.error?.ErrorMessage != null ? error.error?.ErrorMessage :"Se enviaron datos incorrectos al servidor.";
                            errorMsg= `${codigosCom.ERROR}:${message}`;
                        }else if( error.status === 500){
                            let message : string = "";
                            const _errorArr = error.message.split('||');
                            if(_errorArr.length >= 2) message =_errorArr[1];
                            message = message === ""? error.message : "";
                            message = error.error?.Message != null && message === "" ? error.error?.Message : "";
                            errorMsg = `${codigosCom.ERROR}:${message}`;
                        } else if(error.status === 401){
                            errorMsg = `${codigosCom.TIMEOUT}:${mensajesCom.MSGTIMEOUT}`;
                        } else if(error.status === 404){
                            errorMsg = `${codigosCom.ERROR}:${mensajesCom.MSG404}`;
                        } else {
                            errorMsg = `${codigosCom.ERROR}:${mensajesCom.MSGERRORSRV}`;
                        }
                    }
                    throw new Error(errorMsg);
                })
            )
    }
}
